import {
  AGREE_DISAGREE_TYPES,
  formatAgreeDisagreeValue,
  replaceUnderscores,
} from "~/common/utils";
import { CompletedRadioAnswer } from "~/common/utils/consultations/shared";

export const formatAgreeDisagreeAnswers = (
  answer: CompletedRadioAnswer[],
  title: string,
) =>
  // agree_disagree questions were all before yes_no_na questions.
  answer.map(({ value }) => {
    if (
      value &&
      (value === AGREE_DISAGREE_TYPES.agree ||
        value === AGREE_DISAGREE_TYPES.disagree)
    ) {
      return formatAgreeDisagreeValue(value, title);
    } else if (value) {
      return replaceUnderscores(value);
    }
    return "";
  });
